(() => {
  const root = document.querySelector('[data-manu-assistant]');
  if (!root || root.dataset.manuReady === 'true') return;
  root.dataset.manuReady = 'true';

  const panel = root.querySelector('[data-manu-panel]');
  const openButton = root.querySelector('[data-manu-open]');
  const closeButton = root.querySelector('[data-manu-close]');
  const conversation = root.querySelector('[data-manu-conversation]');
  const form = root.querySelector('[data-manu-form]');
  const input = root.querySelector('[data-manu-input]');
  const submitButton = form.querySelector('button[type="submit"]');
  const avatarUrl = root.querySelector('.manu-assistant__header-avatar img').src;
  const shopRoot = window.Shopify?.routes?.root || '/';
  const apiEndpoint = (root.dataset.apiEndpoint || '').trim();
  const aiHistory = [];

  const routes = { order: '/apps/17track', contact: '/pages/contactez-nous', cart: '/cart' };
  const state = {
    forcedUniverse: '', profile: null, pendingQuestion: null,
    questionQueue: [], busy: false, lastProducts: []
  };

  const normalize = (value = '') => value
    .toLocaleLowerCase('fr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
  const includesAny = (text, words) => words.some((word) => text.includes(normalize(word)));

  const questionSets = {
    material: {
      id: 'material', text: 'Sur quelle matière allez-vous surtout travailler ?',
      options: [['🧱 Béton / pierre', 'beton'], ['🧱 Brique / parpaing', 'maconnerie'], ['🪵 Bois', 'bois'], ['⚙️ Métal', 'metal'], ['Plusieurs matières', 'multi']]
    },
    cuttingMaterial: {
      id: 'material', text: 'Quelle matière devez-vous couper principalement ?',
      options: [['🪵 Bois', 'bois'], ['⚙️ Métal', 'metal'], ['🧱 Maçonnerie', 'maconnerie'], ['◻️ Carrelage', 'carrelage'], ['🌿 Branches / végétaux', 'vegetaux']]
    },
    usage: {
      id: 'usage', text: 'À quelle fréquence allez-vous l’utiliser ?',
      options: [['Ponctuellement', 'ponctuel'], ['Régulièrement', 'regulier'], ['Usage intensif / chantier', 'intensif']]
    },
    power: {
      id: 'power', text: 'Vous préférez un outil filaire ou sans fil ?',
      options: [['🔋 Sans fil', 'sans-fil'], ['🔌 Filaire', 'filaire'], ['Peu importe', 'indifferent']]
    },
    budget: {
      id: 'budget', text: 'Quel budget maximum souhaitez-vous consacrer au produit principal ?',
      options: [['Moins de 100 €', '100'], ['100 à 250 €', '250'], ['250 à 500 €', '500'], ['Budget flexible', 'flexible']]
    },
    workEnvironment: {
      id: 'environment', text: 'Dans quel environnement travaillez-vous principalement ?',
      options: [['🏗️ Chantier / BTP', 'chantier'], ['🏭 Atelier / industrie', 'industrie'], ['🌧️ Extérieur / humidité', 'exterieur'], ['📦 Logistique / manutention', 'logistique']]
    },
    workRisk: {
      id: 'risk', text: 'Quel est le risque ou le besoin prioritaire ?',
      options: [['Chocs / écrasement', 'chocs'], ['Glissade', 'antiderapant'], ['Eau / froid', 'impermeable'], ['Confort longue durée', 'confort']]
    },
    space: {
      id: 'space', text: 'Où sera installé l’équipement ou le mobilier ?',
      options: [['🏠 Intérieur', 'interieur'], ['🌤️ Terrasse couverte', 'terrasse'], ['🌧️ Extérieur exposé', 'exterieur'], ['🧰 Garage / atelier', 'garage']]
    },
    dimensions: {
      id: 'dimensions', text: 'Quelles dimensions maximales avez-vous ? Écrivez-les simplement, par exemple « 120 × 60 cm ».', options: []
    },
    surface: {
      id: 'surface', text: 'Quelle surface voulez-vous traiter ?',
      options: [['Bois / meuble', 'bois'], ['Mur / plafond', 'mur'], ['Métal', 'metal'], ['Sol / terrasse', 'sol']]
    },
    gardenTask: {
      id: 'task', text: 'Quelle tâche voulez-vous réaliser au jardin ?',
      options: [['Tondre la pelouse', 'tondeuse'], ['Tailler une haie', 'taille haie'], ['Couper des branches', 'elagueuse'], ['Nettoyer / souffler', 'souffleur'], ['Arroser', 'arrosage']]
    },
    exactProject: {
      id: 'task', text: 'Décrivez la tâche précise en une phrase : ce que vous voulez faire et sur quoi.', options: []
    }
  };

  const flows = {
    drill: {
      universe: 'bricolage', label: 'le perçage', questions: ['material', 'usage', 'power', 'budget'],
      exclude: ['foret', 'meche', 'trepan', 'adaptateur', 'burin seul', 'coffret de forets'],
      complements: (profile) => [profile.material === 'beton' ? 'foret beton sds' : 'foret perceuse', 'lunettes protection']
    },
    screw: {
      universe: 'bricolage', label: 'le vissage et l’assemblage', questions: ['usage', 'power', 'budget'],
      exclude: ['embout seul', 'lot embouts', 'adaptateur'], complements: () => ['embout vissage', 'gants travail']
    },
    cut: {
      universe: 'bricolage', label: 'la découpe', questions: ['cuttingMaterial', 'usage', 'power', 'budget'],
      exclude: ['lame seule', 'disque seul', 'guide seul'],
      complements: (profile) => [profile.material === 'bois' ? 'lame scie bois' : 'disque decoupe', 'lunettes protection']
    },
    sand: {
      universe: 'bricolage', label: 'le ponçage et la finition', questions: ['surface', 'usage', 'power', 'budget'],
      exclude: ['papier abrasif', 'disque abrasif', 'plateau seul'], complements: () => ['papier abrasif', 'masque protection']
    },
    workShoes: {
      universe: 'travail', label: 'les chaussures de sécurité', questions: ['workEnvironment', 'workRisk', 'budget'],
      exclude: ['semelle seule', 'lacets'], complements: () => ['chaussettes travail', 'vetement travail']
    },
    workPpe: {
      universe: 'travail', label: 'l’équipement de protection', questions: ['workEnvironment', 'workRisk', 'budget'],
      exclude: [], complements: () => []
    },
    garden: {
      universe: 'maison', label: 'l’entretien du jardin', questions: ['gardenTask', 'usage', 'power', 'budget'],
      exclude: ['lame seule', 'fil seul', 'batterie seule', 'chargeur seul'], complements: () => ['gants jardinage', 'lunettes protection']
    },
    clean: {
      universe: 'maison', label: 'le nettoyage', questions: ['surface', 'usage', 'power', 'budget'],
      exclude: ['sac aspirateur', 'filtre seul', 'brosse seule'], complements: () => ['gants menage']
    },
    furnish: {
      universe: 'maison', label: 'l’aménagement', questions: ['space', 'dimensions', 'budget'], exclude: [], complements: () => []
    },
    generic: {
      universe: '', label: 'votre projet', questions: ['exactProject', 'usage', 'budget'], exclude: [], complements: () => []
    }
  };

  function syncPreviewOffset() {
    const isPreview = new URLSearchParams(window.location.search).has('preview_theme_id') || Boolean(document.getElementById('PBarNextFrame'));
    root.classList.toggle('manu-assistant--preview', isPreview);
  }

  function openPanel() {
    panel.hidden = false;
    openButton.hidden = true;
    openButton.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => input.focus(), 80);
  }

  function closePanel() {
    panel.hidden = true;
    openButton.hidden = false;
    openButton.setAttribute('aria-expanded', 'false');
    openButton.focus();
  }

  function scrollToBottom() { conversation.scrollTop = conversation.scrollHeight; }
  function removeActiveChoices() {
    conversation.querySelectorAll('.manu-assistant__quick-replies:not([data-manu-initial])').forEach((group) => group.remove());
  }

  function createMessage(role, text, link) {
    const wrapper = document.createElement('div');
    wrapper.className = `manu-assistant__message manu-assistant__message--${role}`;
    if (role === 'bot') {
      const avatar = document.createElement('span');
      avatar.className = 'manu-assistant__mini-avatar';
      avatar.setAttribute('aria-hidden', 'true');
      const image = document.createElement('img');
      image.src = avatarUrl;
      image.alt = '';
      image.width = 36;
      image.height = 36;
      avatar.appendChild(image);
      wrapper.appendChild(avatar);
    }
    const bubble = document.createElement('div');
    bubble.className = 'manu-assistant__bubble';
    String(text).split('\n').filter(Boolean).forEach((line) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = line;
      bubble.appendChild(paragraph);
    });
    if (link?.url && link?.label) {
      const anchor = document.createElement('a');
      anchor.className = 'manu-assistant__link';
      anchor.href = link.url;
      anchor.textContent = `${link.label} →`;
      bubble.appendChild(anchor);
    }
    wrapper.appendChild(bubble);
    conversation.appendChild(wrapper);
    scrollToBottom();
    return wrapper;
  }

  function showTyping(label = 'Manu cherche dans le catalogue') {
    const wrapper = document.createElement('div');
    wrapper.className = 'manu-assistant__message manu-assistant__message--bot';
    wrapper.dataset.manuTyping = 'true';
    const avatar = document.createElement('span');
    avatar.className = 'manu-assistant__mini-avatar';
    avatar.setAttribute('aria-hidden', 'true');
    const image = document.createElement('img');
    image.src = avatarUrl;
    image.alt = '';
    image.width = 36;
    image.height = 36;
    avatar.appendChild(image);
    const bubble = document.createElement('div');
    bubble.className = 'manu-assistant__bubble manu-assistant__bubble--typing';
    const labelNode = document.createElement('span');
    labelNode.className = 'manu-assistant__typing-label';
    labelNode.textContent = label;
    const dots = document.createElement('span');
    dots.className = 'manu-assistant__typing';
    dots.setAttribute('aria-label', label);
    dots.append(document.createElement('span'), document.createElement('span'), document.createElement('span'));
    bubble.append(labelNode, dots);
    wrapper.append(avatar, bubble);
    conversation.appendChild(wrapper);
    scrollToBottom();
    return wrapper;
  }

  function renderChoices(question) {
    if (!question.options?.length) return;
    const group = document.createElement('div');
    group.className = 'manu-assistant__quick-replies';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Réponses proposées');
    question.options.forEach(([label, value]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.manuAnswer = value;
      button.dataset.manuField = question.id;
      button.textContent = label;
      group.appendChild(button);
    });
    conversation.appendChild(group);
    scrollToBottom();
  }

  function renderAIChoices(replies) {
    if (!Array.isArray(replies) || !replies.length) return;
    removeActiveChoices();
    const group = document.createElement('div');
    group.className = 'manu-assistant__quick-replies';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Réponses suggérées par Manu');
    replies.slice(0, 4).forEach((reply) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.manuAiReply = reply;
      button.textContent = reply;
      group.appendChild(button);
    });
    conversation.appendChild(group);
    scrollToBottom();
  }

  function detectFlow(message, forcedUniverse = '') {
    const text = normalize(message);
    if (/chauss|botte.*secur|proteger.*pied/.test(text)) return 'workShoes';
    if (/perc|perfor|faire.*trou|chevill|fixer|fixation|accroch|poser.*etagere/.test(text)) return 'drill';
    if (/viss|deviss|assembl/.test(text)) return 'screw';
    if (/ponc|decap|polir|lustr/.test(text)) return 'sand';
    if (/decoup|couper|sci|tronconn|elagu|meul/.test(text)) return 'cut';
    if (/tond|pelouse|taille.*haie|debrouss|arros|souffl|jardin/.test(text)) return 'garden';
    if (/nettoy|aspir|lavage|laver|haute.*pression/.test(text)) return 'clean';
    if (/meuble|mobilier|amenag|rangement|terrasse|table|chaise|salon.*jardin|armoire|etagere/.test(text)) return 'furnish';
    if (/epi|casque|gant|lunette|masque|protection|vetement.*travail|securite.*travail/.test(text)) return 'workPpe';
    if (forcedUniverse === 'travail') return 'workPpe';
    if (forcedUniverse === 'maison') return 'furnish';
    return 'generic';
  }

  function extractKnownDetails(message, profile) {
    const text = normalize(message);
    const budgetMatch = text.match(/(?:budget|maximum|max|jusqu a|moins de)?\s*(\d{2,4})\s*(?:euro|eur)?/);
    if (budgetMatch && Number(budgetMatch[1]) >= 30) profile.budget = Number(budgetMatch[1]);
    if (includesAny(text, ['beton', 'pierre', 'dalle'])) profile.material = 'beton';
    else if (includesAny(text, ['brique', 'parpaing', 'maconnerie'])) profile.material = 'maconnerie';
    else if (includesAny(text, ['carrelage', 'faience'])) profile.material = 'carrelage';
    else if (includesAny(text, ['metal', 'acier', 'fer'])) profile.material = 'metal';
    else if (includesAny(text, ['bois', 'mdf', 'contreplaque'])) profile.material = 'bois';
    if (includesAny(text, ['tous les jours', 'intensif', 'chantier', 'professionnel', 'quotidien'])) profile.usage = 'intensif';
    else if (includesAny(text, ['regulier', 'souvent', 'chaque semaine'])) profile.usage = 'regulier';
    else if (includesAny(text, ['occasionnel', 'ponctuel', 'une fois'])) profile.usage = 'ponctuel';
    if (includesAny(text, ['sans fil', 'batterie'])) profile.power = 'sans-fil';
    else if (includesAny(text, ['filaire', 'sur secteur', 'avec fil'])) profile.power = 'filaire';
    if (includesAny(text, ['dehors', 'exterieur', 'pluie'])) profile.space = 'exterieur';
    else if (includesAny(text, ['terrasse'])) profile.space = 'terrasse';
    else if (includesAny(text, ['garage', 'atelier'])) profile.space = 'garage';
    else if (includesAny(text, ['interieur', 'salon', 'chambre', 'cuisine'])) profile.space = 'interieur';
    if (profile.flow === 'garden') {
      if (includesAny(text, ['tondre', 'pelouse'])) profile.task = 'tondeuse';
      else if (includesAny(text, ['haie'])) profile.task = 'taille haie';
      else if (includesAny(text, ['branche', 'elaguer'])) profile.task = 'elagueuse';
      else if (includesAny(text, ['souffler', 'feuille'])) profile.task = 'souffleur';
      else if (includesAny(text, ['arroser', 'arrosage'])) profile.task = 'arrosage';
    }
  }

  function getQuestion(key) {
    const source = questionSets[key];
    return source ? { ...source, options: source.options ? [...source.options] : [] } : null;
  }

  function buildQuestionQueue(profile) {
    return flows[profile.flow].questions.map(getQuestion).filter(Boolean).filter((question) => !profile[question.id]);
  }

  function beginUniverse(universe, label) {
    if (apiEndpoint) {
      handleAIMessage(label, { universe });
      return;
    }
    removeActiveChoices();
    state.forcedUniverse = universe;
    state.profile = null;
    state.pendingQuestion = null;
    createMessage('user', label);
    const prompts = {
      travail: 'Très bien. Quel est votre métier, votre environnement de travail et l’équipement que vous cherchez ?',
      bricolage: 'Très bien. Décrivez ce que vous voulez réaliser et la matière concernée. Exemple : « fixer une étagère dans un mur en béton ».',
      maison: 'Très bien. Quel espace voulez-vous aménager ou améliorer, et pour quel usage ?'
    };
    createMessage('bot', prompts[universe]);
  }

  function startProject(message) {
    const flow = detectFlow(message, state.forcedUniverse);
    const definition = flows[flow];
    const profile = {
      flow, universe: state.forcedUniverse || definition.universe, project: message,
      task: flow === 'generic' ? message : '', material: '', surface: '', usage: '', power: '', budget: '',
      environment: '', risk: '', space: '', dimensions: ''
    };
    extractKnownDetails(message, profile);
    state.profile = profile;
    state.questionQueue = buildQuestionQueue(profile);
    state.pendingQuestion = null;
    createMessage('bot', `J’ai compris : votre besoin concerne ${definition.label}. Je vérifie les critères qui changent vraiment le choix du produit.`);
    askNextQuestion();
  }

  function askNextQuestion() {
    state.pendingQuestion = state.questionQueue.shift() || null;
    if (!state.pendingQuestion) return recommendProducts();
    createMessage('bot', state.pendingQuestion.text);
    renderChoices(state.pendingQuestion);
  }

  function acceptAnswer(field, value, label) {
    if (!state.profile || !state.pendingQuestion) return;
    removeActiveChoices();
    createMessage('user', label || value);
    if (field === 'budget') {
      const amount = String(value).match(/\d{2,4}/);
      state.profile.budget = value === 'flexible' ? 'flexible' : (amount ? Number(amount[0]) : 'flexible');
    } else if (field === 'refinement') {
      state.profile.project = `${state.profile.project} ${value}`;
      extractKnownDetails(value, state.profile);
    } else {
      state.profile[field] = value;
    }
    state.pendingQuestion = null;
    askNextQuestion();
  }

  function meaningfulTerms(value) {
    const stopWords = new Set([
      'avec', 'pour', 'dans', 'sans', 'sous', 'chez', 'plus', 'moins', 'faire', 'veux', 'voudrais',
      'besoin', 'cherche', 'dois', 'mon', 'ma', 'mes', 'un', 'une', 'des', 'les', 'sur', 'qui', 'que',
      'quoi', 'comment', 'projet', 'installer', 'amenager', 'equiper', 'realiser', 'outil', 'produit'
    ]);
    return normalize(value).split(' ').filter((word) => word.length > 2 && !stopWords.has(word)).slice(0, 5);
  }

  function searchQueries(profile) {
    const material = profile.material || profile.surface;
    switch (profile.flow) {
      case 'drill':
        if (['beton', 'maconnerie'].includes(material)) return ['perforateur sds', 'marteau perforateur', 'perforateur'];
        return ['perceuse visseuse', 'perceuse', 'perceuse sans fil'];
      case 'screw': return ['visseuse', 'perceuse visseuse', 'visseuse a choc'];
      case 'cut':
        if (material === 'bois') return ['scie circulaire', 'scie sauteuse', 'scie bois'];
        if (material === 'metal') return ['meuleuse', 'scie metal', 'outil decoupe metal'];
        if (material === 'carrelage') return ['coupe carrelage', 'carrelette'];
        if (material === 'vegetaux') return ['elagueuse', 'tronconneuse'];
        return ['outil decoupe', 'scie', 'meuleuse'];
      case 'sand': return ['ponceuse', `ponceuse ${material || ''}`.trim()];
      case 'workShoes': return ['chaussures securite', 'chaussure travail', 'bottes securite'];
      case 'workPpe': {
        const terms = meaningfulTerms(profile.project).filter((term) => !['travail', 'securite', 'protection'].includes(term));
        return [terms.join(' ') || 'equipement protection', 'epi travail', 'protection travail'];
      }
      case 'garden': return [profile.task || 'outil jardin', 'outil jardin', 'equipement jardin'];
      case 'clean': return [`${profile.task || 'nettoyeur'} ${material || ''}`.trim(), 'aspirateur nettoyeur', 'nettoyage'];
      case 'furnish': {
        const terms = meaningfulTerms(profile.project).filter((term) => !['maison', 'jardin', 'exterieur'].includes(term));
        return [terms.join(' ') || 'mobilier', `${profile.space || ''} mobilier`.trim(), 'amenagement'];
      }
      default: {
        const terms = meaningfulTerms(`${profile.task} ${profile.project}`);
        return [terms.join(' '), terms.slice(0, 3).join(' '), terms[0] || 'equipement'];
      }
    }
  }

  async function searchCatalog(query, limit = 10) {
    if (!query) return [];
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(limit));
    params.set('resources[options][unavailable_products]', 'hide');
    params.set('resources[options][fields]', 'title,product_type,tag,vendor,variants.title,body');
    const response = await fetch(`${shopRoot}search/suggest.json?${params.toString()}`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Recherche indisponible (${response.status})`);
    const payload = await response.json();
    return payload?.resources?.results?.products || [];
  }

  function parsePrice(value) {
    if (typeof value === 'number') return value > 5000 ? value / 100 : value;
    if (!value) return 0;
    const cleaned = String(value).replace(/[^0-9,.-]/g, '').replace(',', '.');
    const parsed = Number.parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function productPrice(product) {
    const prices = (product.variants || []).map((variant) => parsePrice(variant.price)).filter((price) => price > 0);
    return prices.length ? Math.min(...prices) : parsePrice(product.price_min || product.price);
  }

  function productText(product) {
    return normalize([
      product.title, product.type, product.product_type, product.vendor,
      Array.isArray(product.tags) ? product.tags.join(' ') : product.tags, product.body
    ].filter(Boolean).join(' '));
  }

  function powerFit(text, preference) {
    if (!preference || preference === 'indifferent') return 'neutral';
    const cordless = includesAny(text, ['sans fil', 'batterie', '18v', '20v', 'powershare']);
    const corded = includesAny(text, ['filaire', 'secteur', '230v']) || /\b\d{3,4}\s*w\b/.test(text);
    if (preference === 'sans-fil') return cordless ? 'match' : (corded ? 'mismatch' : 'unknown');
    if (preference === 'filaire') return corded ? 'match' : (cordless ? 'mismatch' : 'unknown');
    return 'neutral';
  }

  function scoreProduct(product, profile, query) {
    const text = productText(product);
    const title = normalize(product.title);
    let score = product.available === false ? -200 : 10;
    meaningfulTerms(query).forEach((term) => {
      if (title.includes(term)) score += 14;
      else if (text.includes(term)) score += 5;
    });
    const flowSignals = {
      drill: ['perforateur', 'perceuse', 'marteau perforateur'],
      screw: ['visseuse', 'perceuse visseuse', 'visseuse a choc'],
      cut: ['scie', 'meuleuse', 'coupe', 'tronconneuse', 'elagueuse'],
      sand: ['ponceuse', 'polisseuse'], workShoes: ['chaussure', 'botte', 'basket securite'],
      workPpe: ['protection', 'travail', 'securite', 'epi'], garden: [normalize(profile.task), 'jardin'],
      clean: ['nettoyeur', 'aspirateur', 'nettoyage'], furnish: ['mobilier', 'meuble', 'table', 'chaise', 'rangement', 'etagere']
    };
    if (includesAny(title, (flowSignals[profile.flow] || []).filter(Boolean))) score += 32;
    if (['beton', 'maconnerie'].includes(profile.material)) {
      if (includesAny(text, ['sds', 'beton', 'maconnerie', 'perforateur'])) score += 22;
      if (includesAny(title, ['perforateur', 'marteau perforateur'])) score += 28;
    } else if (profile.material && text.includes(profile.material)) score += 14;
    const powerCompatibility = powerFit(text, profile.power);
    if (powerCompatibility === 'match') score += 28;
    if (powerCompatibility === 'mismatch') score -= 42;
    if (profile.usage === 'intensif' && includesAny(text, ['professionnel', 'pro', 'brushless', 'robuste', 'intensif', 'chantier'])) score += 12;
    if (profile.environment && text.includes(profile.environment)) score += 10;
    if (profile.risk && text.includes(profile.risk)) score += 12;
    if (profile.space && text.includes(profile.space)) score += 10;
    if (profile.dimensions) {
      const dimensions = String(profile.dimensions).match(/\d{2,4}/g) || [];
      dimensions.forEach((dimension) => { if (text.includes(dimension)) score += 6; });
    }
    const price = productPrice(product);
    if (typeof profile.budget === 'number' && price) {
      if (price <= profile.budget) score += 16;
      else score -= Math.min(55, 5 + ((price - profile.budget) / Math.max(profile.budget, 1)) * 45);
    }
    if ((flows[profile.flow]?.exclude || []).some((term) => title.includes(normalize(term)))) score -= 100;
    return score;
  }

  async function findRecommendations(profile) {
    const queries = [...new Set(searchQueries(profile).filter(Boolean))].slice(0, 3);
    const batches = await Promise.allSettled(queries.map((query) => searchCatalog(query)));
    const products = [];
    const seen = new Set();
    batches.forEach((batch, index) => {
      if (batch.status !== 'fulfilled') return;
      batch.value.forEach((product) => {
        const key = product.handle || product.id;
        if (!key || seen.has(key)) return;
        seen.add(key);
        products.push({ ...product, _query: queries[index] });
      });
    });
    return products
      .map((product) => ({ ...product, _score: scoreProduct(product, profile, product._query) }))
      .filter((product) => product._score > -30 && product.available !== false)
      .sort((a, b) => b._score - a._score)
      .slice(0, 3);
  }

  async function findComplements(profile, excludedHandles) {
    const queries = (flows[profile.flow]?.complements(profile) || []).slice(0, 2);
    if (!queries.length) return [];
    const batches = await Promise.allSettled(queries.map((query) => searchCatalog(query, 5)));
    const complements = [];
    batches.forEach((batch, index) => {
      if (batch.status !== 'fulfilled') return;
      const terms = meaningfulTerms(queries[index]);
      const match = batch.value.find((product) => {
        const title = normalize(product.title);
        return product.available !== false && !excludedHandles.has(product.handle) && terms.some((term) => title.includes(term));
      });
      if (match && !complements.some((item) => item.handle === match.handle)) complements.push(match);
    });
    return complements;
  }

  function formatPrice(price) {
    return price ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price) : 'Prix sur la fiche';
  }

  function productPriceLabel(product) {
    const prices = (product.variants || []).map((variant) => parsePrice(variant.price)).filter((price) => price > 0);
    const price = prices.length ? Math.min(...prices) : productPrice(product);
    if (!price) return 'Prix sur la fiche';
    const varies = new Set(prices.map((value) => value.toFixed(2))).size > 1;
    return `${varies ? 'À partir de ' : ''}${formatPrice(price)}`;
  }

  function productImageUrl(product) {
    const source = typeof product.image === 'string' ? product.image : product.image?.url;
    return source?.startsWith('//') ? `https:${source}` : (source || '');
  }

  function availableVariants(product) { return (product.variants || []).filter((variant) => variant.available !== false); }

  function productReason(product, profile) {
    if (product.reason) return /[.!?]$/.test(product.reason) ? product.reason : `${product.reason}.`;
    const text = productText(product);
    const reasons = [];
    if (['beton', 'maconnerie'].includes(profile.material) && includesAny(text, ['sds', 'perforateur', 'beton'])) reasons.push('adapté aux matériaux de maçonnerie');
    else if (profile.material && text.includes(profile.material)) reasons.push(`adapté au ${profile.material}`);
    const powerCompatibility = powerFit(text, profile.power);
    if (powerCompatibility === 'match' && profile.power === 'sans-fil') reasons.push('format sans fil conforme à votre préférence');
    if (powerCompatibility === 'match' && profile.power === 'filaire') reasons.push('alimentation filaire conforme à votre préférence');
    if (profile.usage === 'intensif' && includesAny(text, ['brushless', 'professionnel', 'pro', 'chantier', 'robuste'])) reasons.push('conçu pour un usage soutenu');
    const price = productPrice(product);
    if (typeof profile.budget === 'number' && price <= profile.budget) reasons.push('dans votre budget');
    if (!reasons.length) reasons.push('caractéristiques proches de votre besoin');
    return `${reasons.slice(0, 2).join(' et ')}.`;
  }

  function renderProductCard(product, profile, index) {
    const card = document.createElement('article');
    card.className = 'manu-assistant__product-card';
    const url = product.url || `/products/${product.handle}`;
    const imageUrl = productImageUrl(product);
    if (imageUrl) {
      const imageLink = document.createElement('a');
      imageLink.className = 'manu-assistant__product-image';
      imageLink.href = url;
      imageLink.setAttribute('aria-label', `Voir ${product.title}`);
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 112;
      image.height = 112;
      imageLink.appendChild(image);
      card.appendChild(imageLink);
    }
    const content = document.createElement('div');
    content.className = 'manu-assistant__product-content';
    const badge = document.createElement('span');
    badge.className = 'manu-assistant__product-badge';
    badge.textContent = index === 0 ? 'Choix le plus cohérent' : index === 1 ? 'Bonne alternative' : 'Autre option adaptée';
    const title = document.createElement('a');
    title.className = 'manu-assistant__product-title';
    title.href = url;
    title.textContent = product.title;
    const meta = document.createElement('p');
    meta.className = 'manu-assistant__product-meta';
    meta.textContent = [product.vendor, productPriceLabel(product)].filter(Boolean).join(' · ');
    const reason = document.createElement('div');
    reason.className = 'manu-assistant__product-reason';
    const reasonLabel = document.createElement('strong');
    reasonLabel.textContent = 'Pourquoi ce choix';
    const reasonList = document.createElement('ul');
    const argumentsList = Array.isArray(product.arguments) && product.arguments.length
      ? product.arguments.slice(0, 4)
      : [productReason(product, profile)];
    argumentsList.forEach((argument) => {
      const item = document.createElement('li');
      item.textContent = argument;
      reasonList.appendChild(item);
    });
    reason.append(reasonLabel, reasonList);
    const delivery = document.createElement('p');
    delivery.className = 'manu-assistant__product-delivery';
    const price = productPrice(product);
    const budgetGap = typeof profile.budget === 'number' && price > profile.budget ? price - profile.budget : 0;
    const deliveryNotes = [];
    if (product.warning) deliveryNotes.push(product.warning);
    if (budgetGap) deliveryNotes.push(`Dépasse le budget de ${formatPrice(budgetGap)}`);
    if (powerFit(productText(product), profile.power) === 'mismatch') deliveryNotes.push(`Alimentation différente : ${profile.power === 'sans-fil' ? 'filaire' : 'sans fil'}`);
    deliveryNotes.push('Délai sur la fiche');
    delivery.textContent = `${deliveryNotes.join(' · ')}.`;
    const actions = document.createElement('div');
    actions.className = 'manu-assistant__product-actions';
    const variants = availableVariants(product);
    const hasOptions = variants.length > 1 && variants.some((variant) => normalize(variant.title) !== 'default title');
    if (variants.length && !hasOptions) {
      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'manu-assistant__add';
      addButton.dataset.manuAdd = String(variants[0].id).split('/').pop();
      addButton.dataset.manuProduct = product.title;
      addButton.textContent = 'Ajouter au panier';
      actions.appendChild(addButton);
    }
    const viewLink = document.createElement('a');
    viewLink.className = 'manu-assistant__view';
    viewLink.href = url;
    viewLink.textContent = hasOptions ? 'Choisir les options' : 'Voir la fiche';
    actions.appendChild(viewLink);
    content.append(badge, title, meta, reason, delivery, actions);
    card.appendChild(content);
    return card;
  }

  function renderProductResults(products, profile) {
    const group = document.createElement('section');
    group.className = 'manu-assistant__products';
    group.setAttribute('aria-label', 'Produits recommandés');
    products.forEach((product, index) => group.appendChild(renderProductCard(product, profile, index)));
    conversation.appendChild(group);
    scrollToBottom();
  }

  function renderComplements(products) {
    if (!products.length) return;
    const section = document.createElement('section');
    section.className = 'manu-assistant__complements';
    const heading = document.createElement('strong');
    heading.textContent = 'Pour réaliser le projet jusqu’au bout';
    const intro = document.createElement('p');
    intro.textContent = 'Ces compléments sont liés à l’usage, pas ajoutés au hasard.';
    section.append(heading, intro);
    products.forEach((product) => {
      const link = document.createElement('a');
      link.className = 'manu-assistant__complement';
      link.href = product.url || `/products/${product.handle}`;
      const imageUrl = productImageUrl(product);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 50;
        image.height = 50;
        link.appendChild(image);
      }
      const copy = document.createElement('span');
      const title = document.createElement('b');
      title.textContent = product.title;
      const price = document.createElement('small');
      price.textContent = productPriceLabel(product);
      copy.append(title, price);
      link.appendChild(copy);
      section.appendChild(link);
    });
    conversation.appendChild(section);
    scrollToBottom();
  }

  function renderRestartChoices() {
    const group = document.createElement('div');
    group.className = 'manu-assistant__quick-replies manu-assistant__quick-replies--after';
    const refine = document.createElement('button');
    refine.type = 'button';
    refine.dataset.manuRefine = 'true';
    refine.textContent = '🎯 Affiner ces résultats';
    const restart = document.createElement('button');
    restart.type = 'button';
    restart.dataset.manuRestart = 'true';
    restart.textContent = '↻ Nouveau projet';
    group.append(refine, restart);
    conversation.appendChild(group);
    scrollToBottom();
  }

  async function handleAIMessage(message, contextOverride = {}) {
    const cleanMessage = message.trim();
    if (!cleanMessage || state.busy) return;
    removeActiveChoices();
    createMessage('user', cleanMessage);
    input.value = '';
    input.style.height = 'auto';
    state.busy = true;
    input.disabled = true;
    submitButton.disabled = true;
    const typing = showTyping('Manu consulte les données Manuzen');
    const previousHistory = aiHistory.slice(-12);
    aiHistory.push({ role: 'user', content: cleanMessage });

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          message: cleanMessage,
          history: previousHistory,
          context: {
            pageType: root.dataset.pageType,
            pageTitle: root.dataset.pageTitle,
            productHandle: root.dataset.productHandle,
            collectionHandle: root.dataset.collectionHandle,
            path: window.location.pathname,
            ...contextOverride
          }
        })
      });
      const payload = await response.json();
      if (!response.ok || !payload.answer) throw new Error(payload.error || 'Réponse IA indisponible');
      typing.remove();
      createMessage('bot', payload.answer);
      aiHistory.push({ role: 'assistant', content: payload.answer });
      if (Array.isArray(payload.products) && payload.products.length) renderProductResults(payload.products, {});
      if (Array.isArray(payload.complements) && payload.complements.length) renderComplements(payload.complements);
      renderAIChoices(payload.suggested_replies);
    } catch (error) {
      typing.remove();
      aiHistory.pop();
      createMessage('bot', 'Je ne peux pas consulter mes données pour le moment. Je préfère ne pas vous donner une réponse approximative.', {
        label: 'Contacter l’équipe Manuzen',
        url: routes.contact
      });
    } finally {
      state.busy = false;
      input.disabled = false;
      submitButton.disabled = false;
      input.focus();
    }
  }

  async function recommendProducts() {
    if (!state.profile || state.busy) return;
    state.busy = true;
    input.disabled = true;
    submitButton.disabled = true;
    const typing = showTyping('Manu compare les produits disponibles');
    try {
      const products = await findRecommendations(state.profile);
      typing.remove();
      if (!products.length) {
        createMessage('bot', 'Je n’ai pas trouvé de produit assez cohérent pour vous conseiller sans risque de vous induire en erreur. Donnez-moi un peu plus de détails ou demandez à l’équipe Manuzen.', { label: 'Contacter Manuzen', url: routes.contact });
        renderRestartChoices();
        return;
      }
      state.lastProducts = products;
      const overBudget = typeof state.profile.budget === 'number' && products.every((product) => productPrice(product) > state.profile.budget);
      const intro = overBudget
        ? 'J’ai trouvé les options techniquement cohérentes, mais elles dépassent toutes le budget indiqué. Je vous les montre clairement pour éviter un mauvais achat.'
        : `Voici ${products.length} produit${products.length > 1 ? 's' : ''} classé${products.length > 1 ? 's' : ''} selon votre projet, votre usage et votre budget.`;
      createMessage('bot', intro);
      renderProductResults(products, state.profile);
      const complements = await findComplements(state.profile, new Set(products.map((product) => product.handle)));
      renderComplements(complements);
      renderRestartChoices();
    } catch (error) {
      typing.remove();
      createMessage('bot', 'La recherche catalogue rencontre un souci temporaire. Votre projet est conservé : réessayez dans un instant ou contactez l’équipe Manuzen.', { label: 'Contacter Manuzen', url: routes.contact });
    } finally {
      state.busy = false;
      input.disabled = false;
      submitButton.disabled = false;
      input.focus();
    }
  }

  async function addToCart(button) {
    const variantId = Number(button.dataset.manuAdd);
    if (!variantId || button.disabled) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Ajout…';
    try {
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Ajout impossible');
      button.textContent = '✓ Ajouté';
      createMessage('bot', `${button.dataset.manuProduct} a bien été ajouté. Vous pouvez continuer le projet ou vérifier votre panier.`, { label: 'Voir mon panier', url: routes.cart });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (error) {
      button.disabled = false;
      button.textContent = originalLabel;
      createMessage('bot', 'Je n’ai pas pu ajouter ce produit automatiquement. Ouvrez sa fiche pour choisir la variante et vérifier sa disponibilité.');
    }
  }

  function resetConversation() {
    removeActiveChoices();
    state.forcedUniverse = '';
    state.profile = null;
    state.pendingQuestion = null;
    state.questionQueue = [];
    state.lastProducts = [];
    createMessage('bot', 'Très bien, repartons de votre besoin. Décrivez ce que vous voulez réaliser, même avec vos propres mots.');
  }

  function handleTypedMessage(message) {
    const cleanMessage = message.trim();
    if (!cleanMessage || state.busy) return;
    if (apiEndpoint) {
      handleAIMessage(cleanMessage);
      return;
    }
    input.value = '';
    input.style.height = 'auto';
    if (/commande|colis|suivi|livraison|retard|transporteur/.test(normalize(cleanMessage))) {
      createMessage('user', cleanMessage);
      createMessage('bot', 'Pour une commande en cours, utilisez le suivi avec votre numéro de colis. L’équipe Manuzen peut aussi vérifier un cas précis.', { label: 'Suivre ma commande', url: routes.order });
      return;
    }
    if (state.pendingQuestion && state.profile) {
      acceptAnswer(state.pendingQuestion.id, cleanMessage, cleanMessage);
      return;
    }
    removeActiveChoices();
    createMessage('user', cleanMessage);
    startProject(cleanMessage);
  }

  syncPreviewOffset();
  window.setTimeout(syncPreviewOffset, 900);
  openButton.addEventListener('click', openPanel);
  closeButton.addEventListener('click', closePanel);
  root.addEventListener('click', (event) => {
    const startButton = event.target.closest('[data-manu-start]');
    if (startButton) {
      beginUniverse(startButton.dataset.manuStart, startButton.textContent.trim());
      return;
    }
    const orderButton = event.target.closest('[data-manu-order]');
    if (orderButton) {
      if (apiEndpoint) {
        handleAIMessage(orderButton.textContent.trim());
        return;
      }
      createMessage('user', orderButton.textContent.trim());
      createMessage('bot', 'Vous pouvez suivre votre colis avec votre numéro de suivi. Pour toute question particulière, l’équipe Manuzen reste disponible.', { label: 'Suivre ma commande', url: routes.order });
      return;
    }
    const answerButton = event.target.closest('[data-manu-answer]');
    if (answerButton) {
      acceptAnswer(answerButton.dataset.manuField, answerButton.dataset.manuAnswer, answerButton.textContent.trim());
      return;
    }
    const aiReplyButton = event.target.closest('[data-manu-ai-reply]');
    if (aiReplyButton) {
      handleAIMessage(aiReplyButton.dataset.manuAiReply || aiReplyButton.textContent.trim());
      return;
    }
    const addButton = event.target.closest('[data-manu-add]');
    if (addButton) {
      addToCart(addButton);
      return;
    }
    if (event.target.closest('[data-manu-restart]')) {
      resetConversation();
      return;
    }
    if (event.target.closest('[data-manu-refine]')) {
      removeActiveChoices();
      if (!state.profile) return;
      state.pendingQuestion = { id: 'refinement', text: '', options: [] };
      createMessage('bot', 'Dites-moi ce que vous voulez ajuster : budget, préférence de marque, puissance, dimensions ou autre critère.');
    }
  });
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    handleTypedMessage(input.value);
  });
  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = `${Math.min(input.scrollHeight, 100)}px`;
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      form.requestSubmit();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });
})();

